export default "__VITE_ASSET__BVbIToB1__"